import { put, takeLeading } from 'redux-saga/effects';

import { apiErrorHandler } from 'utils';

import placeContactsApi from 'api/placeContactsApi';
import { RESET_FORM_SUCCESS } from 'store/edit-location/actionTypes';
import {
  GET_PLACE_CONTACTS,

  GET_PLACE_CONTACT_DETAILS,

  ADD_PLACE_CONTACT,
  ADD_PLACE_CONTACT_FAILED,
  ADD_PLACE_CONTACT_SUCCESS,

  EDIT_PLACE_CONTACT,
  EDIT_PLACE_CONTACT_SUCCESS,
  EDIT_PLACE_CONTACT_FAILED,

  DELETE_PLACE_CONTACT,
  DELETE_PLACE_CONTACT_SUCCESS,
  DELETE_PLACE_CONTACT_FAILED,
} from './actionTypes';
import {
  actionGetPlaceContactsSuccess,
  actionGetPlaceContactsFailed,

  actionGetPlaceContactDetailsSuccess,
  actionGetPlaceContactDetailsFailed,
} from './actions';

function* getPlaceContacts({ payload }) {
  try {
    const response = yield placeContactsApi.getPlaceContacts(payload);

    yield put(
      actionGetPlaceContactsSuccess(response.payload),
    );
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetPlaceContactsFailed());
  }
}

function* getPlaceContactDetails({ payload }) {
  try {
    const response = yield placeContactsApi.getPlaceContactDetails(payload);

    yield put(
      actionGetPlaceContactDetailsSuccess(response.payload),
    );
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetPlaceContactDetailsFailed());
  }
}

function* addPlaceContact({ payload }) {
  const { result, callBack } = payload;
  try {
    const response = yield placeContactsApi.addPlaceContacts(result);

    yield put({
      type: ADD_PLACE_CONTACT_SUCCESS,
    });

    yield put({
      type: RESET_FORM_SUCCESS,
    });

    callBack(response?.payload);
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: ADD_PLACE_CONTACT_FAILED,
    });
  }
}

function* editPlaceContact({ payload }) {
  const { callBack } = payload;
  try {
    yield placeContactsApi.editPlaceContact(payload);

    yield put({
      type: EDIT_PLACE_CONTACT_SUCCESS,
    });

    yield put({
      type: RESET_FORM_SUCCESS,
    });

    callBack();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: EDIT_PLACE_CONTACT_FAILED,
    });
  }
}

function* deletePlaceContact({ payload }) {
  const { callBack } = payload;

  try {
    yield placeContactsApi.deletePlaceContact(payload);

    yield put({
      type: DELETE_PLACE_CONTACT_SUCCESS,
    });

    callBack();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: DELETE_PLACE_CONTACT_FAILED,
    });
  }
}

export default function* placeContactsSaga() {
  yield takeLeading(GET_PLACE_CONTACTS, getPlaceContacts);
  yield takeLeading(GET_PLACE_CONTACT_DETAILS, getPlaceContactDetails);
  yield takeLeading(ADD_PLACE_CONTACT, addPlaceContact);
  yield takeLeading(EDIT_PLACE_CONTACT, editPlaceContact);
  yield takeLeading(DELETE_PLACE_CONTACT, deletePlaceContact);
}
